export default "__VITE_ASSET__8009ce02__"